var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"c-header-bar-logo",attrs:{"to":"/","itemprop":"url","aria-label":"logo"}},[_c('div',{ref:"logo"})])}
var staticRenderFns = []

export { render, staticRenderFns }